import { createFileRoute } from "@tanstack/react-router"
import { ExtractDataPage } from "@/features/schema-management/pages/ExtractDataPage"

export const Route = createFileRoute("/_authenticated/agent/document/extract/")({
    component: ExtractDataPage,
})
